import { render } from "./FilterLabel.vue?vue&type=template&id=6976be81&scoped=true"
import script from "./FilterLabel.vue?vue&type=script&lang=js"
export * from "./FilterLabel.vue?vue&type=script&lang=js"

import "./FilterLabel.vue?vue&type=style&index=0&id=6976be81&lang=scss&scoped=true"
import "./FilterLabel.vue?vue&type=style&index=1&id=6976be81&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6976be81"]])

export default __exports__